/**
 * SVG country flag (flag-icons). Emoji flags are not rendered on Windows, where
 * Chrome falls back to the bare ISO letters, so every flag in the portal goes
 * through this component instead.
 */
export function CountryFlag({ code, className }: { code: string; className?: string }) {
  const iso = String(code || "").trim().toLowerCase();
  if (!/^[a-z]{2}$/.test(iso)) return null;
  return <span className={`fi fi-${iso} fw-flag${className ? ` ${className}` : ""}`} aria-hidden="true" />;
}
